module.exports = __webpack_public_path__ + "img/锻炼报告btn.fede6f48.jpg";